var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashedCurvedSearchLineMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.704,
    height: 84.512,
    viewBox: "0 0 60.704 84.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 207",
    d: "M0 0c3.595 12.439 38.045 39.669 74.755 48.664",
    transform: "rotate(-90 41.915 41.638)",
    style: {
      strokeDasharray: 4,
      fill: "none",
      stroke: "#da9b28",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 208",
    d: "M10.278 0 0 10.278l10.278 9.412",
    transform: "rotate(103 27.457 26.742)",
    style: {
      fill: "none",
      stroke: "#da9b28",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedCurvedSearchLineMobile);
export default __webpack_public_path__ + "static/media/dashed-curved-search-line-mobile.a18fce94feb337ef3da23de5495fff69.svg";
export { ForwardRef as ReactComponent };